import { Dimensions } from '../types'

export const checkForHorizontalBlock = (size: Dimensions) => size.width > size.height
